'use es6';

import http from 'hub-http/clients/apiClient';
import noAuthHttp from 'hub-http/clients/noAuthApiClient';
import { getFullUrl } from 'hubspot-url-utils';
import getEarlyRequesterResult from 'pricing-pages-lib/api/getEarlyRequesterResult';
import { getIsQAProxy } from 'pricing-pages-lib/utils/proxyUtils';
const PUBLIC_ENDPOINT = 'monetization/v3/product';
const ENDPOINT = 'monetization/v3/product/in-app';
export const getProducts = () => {
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${ENDPOINT}`;
  const earlyRequest = getEarlyRequesterResult('product');
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => http.get(url)) : null;
  return earlyRequestWithRetry || http.get(url);
};
export const getPublicProducts = () => {
  const url = `${getFullUrl('app-api', getIsQAProxy() ? {
    envOverride: 'qa'
  } : {})}/${PUBLIC_ENDPOINT}`;
  const earlyRequest = getEarlyRequesterResult('product');
  const earlyRequestWithRetry = earlyRequest ? earlyRequest.catch(() => noAuthHttp.get(url)) : null;
  return earlyRequestWithRetry || noAuthHttp.get(url);
};